import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    selectedTweets: [],
};

const tweetsSlice = createSlice({
    name: 'tweets',
    initialState,
    reducers: {
        setSelectedTweets: (state, { payload }) => {
            state.selectedTweets = payload;
        }
    },
})

export const { setSelectedTweets } = tweetsSlice.actions
export default tweetsSlice.reducer